import React from "react";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import { useMediaQuery } from "@uidotdev/usehooks";
import Form from "./Form";
import Footer from "./Footer";
import imageSuse from "../catalog/ikonica-suse-2025.png";
import imageGrad from "../catalog/grad_ikonica.png";
import imageToplotniTalasi from "../catalog/toplotni-talasi-ikonica2.jpg";
import imageLedenaKisa from "../catalog/ledena-kisa-ikonica.png";

export default function Katalog() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const allDevices = useMediaQuery("only screen and (min-width : 769px)");
  return (
    <>
      {allDevices && <NavBar />}
      {isSmallDevice && <NavBarMobile />}
      <div
        style={{
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
        className="container mx-auto text-center min-h-screen max-w-screen-xl pt-6"
      >
        <div className="flex justify-start items-center">
          <h1 className="text-3xl lg:text-4xl text-blue-400 font-semibold mb-4 pb-2 text-center lg:text-left">
            {" "}
            KATALOG VREMENSKIH I KLIMATSKIH EKSTREMA U SRBIJI
          </h1>
        </div>
        <div className="mx-auto text-left">
          <hr />
          <p className="px-5 sm:px-0 pt-5 sm:pt-0 text-justify sm:text-left md:pt-4">
            Uvodna napomena: EXTREMES katalog biće regularno ažuriran tokom
            perioda realizacije projekta pa su moguće relativno česte izmene i
            dopune u smislu sadržaja, prezentovanih informacija, slika i
            grafika. U tom smislu pozivamo sve korisnike kataloga da povremeno
            proveravaju da li je došlo do izmena i dopuna kako bi imali pristup
            najsvežijim informacijama.
          </p>
          <br />
        </div>

        <div className="wrapper max-w-screen-xl mx-auto">
          <a href="/suse">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>SUŠE</h2>
                <p>
                  Osmotreni trendovi i <br />
                  buduće promene
                </p>
              </div>
              <img src={imageSuse} alt="Suše" />
            </div>
          </a>

          <a href="/grad">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>GRADONOSNE OLUJE</h2>
                <p>Osmotreni podaci, trendovi, klimatologija i indeksi</p>
              </div>
              <img src={imageGrad} alt="Gradonosne oluje" />
            </div>
          </a>

          <a href="/toplotni-talasi">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>TOPLOTNI TALASI</h2>
                <p>
                  Osmotreni podaci i <br />
                  buduće projekcije i trendovi
                </p>
              </div>
              <img src={imageToplotniTalasi} alt="Toplotni talasi" />
            </div>
          </a>

          <a href="/ledene-kise">
            <div className="deoKatalog">
              <div className="textKatalog">
                <h2>LEDENA KIŠA</h2>
                <p>
                  Osmotreni podaci, trendovi, trajanje, vertikalni profili
                  atmosfere
                </p>
              </div>
              <img src={imageLedenaKisa} alt="Ledena kiša" />
            </div>
          </a>
        </div>
      </div>
      <Form />
      <Footer />
    </>
  );
}
